import React from 'react';
import { withRouter } from 'react-router-dom';
import Chart from './Chart';
import { user_token } from '../helpers/Global';
import { api_route, user_logout } from '../helpers/Global';
import queryString from 'query-string';

class Home extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            infolivreur: [],
            time_param: '',
        }
    }
    
    componentDidMount() {
        if (!user_token()) {
            this.props.history.push(`/user-logout`);
        }
        this.componentDidUpdate();
    }
    
    componentDidUpdate() {
        var params = queryString.parse(this.props.location.search);
        var time_param = params.t;

        if (this.state.time_param !== time_param) {
            fetch(api_route('info-livreur'), { method: 'GET' })
                .then(resp => resp.json())
                .then(resp => {
                    if (resp.response === 'error-connected') {
                        user_logout();
                        this.props.history.push(`/user-logout`);
                    } else if (resp['info-general']) {
                        var livreur = resp['info-general'];
                        this.setState({
                            infolivreur: livreur
                        });
                    }
                })
               .catch(err => {
                    this.props.loaderDisplay(false);
                    this.props.openErrorSystem(true);
                })
            
            this.setState({
                time_param: time_param,
            });
        }
    }
    
    render() {
        //var livreur = this.props.livreur;
        var livreur = this.state.infolivreur;
        return (
            <React.Fragment>

                <div className="row">
                    <div className="banner gradient-template col-12 mb-4 pb-5">
                        <h2 className="text-center my-5 font-weight-light">Bienvenu<br />{livreur.livreur_name}</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="container top-60">
                        <div className="row">
                             <div className="col-12 col-md-6 ">
                                <div className="card border-0 shadow-sm mb-4">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="mb-0"><span className="subtitle">Total livraison</span></h6>
                                                <h3 className="font-weight-normal text-danger mt-2">{livreur.livreur_total_brute} Dhs</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6 ">
                                <div className="card border-0 shadow-sm mb-4">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="mb-0"><span className="subtitle">Ma commission</span></h6>
                                                <h3 className="font-weight-normal text-warning mt-2">{livreur.livreur_total_comission} Dhs</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6 ">
                                <div className="card border-0 shadow-sm mb-4">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="mb-0"><span className="subtitle">Total à verser</span></h6>
                                                <h3 className="font-weight-normal text-success mt-2">{livreur.livreur_total_credit} Dhs</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6 ">
                                <div className="card border-0 shadow-sm mb-4">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="mb-0"><span className="subtitle">Livré</span></h6>
                                                <h3 className="font-weight-normal text-success mt-2">{livreur.livreur_total_delivered} colis</h3>
                                            </div>
                                            {livreur.livreur_pourc_delivred && (
                                                <div className="col-auto pl-0 align-self-center">
                                                    <div className="w70">
                                                        <Chart data={[{ color: '#00ca47', value: Math.round(livreur.livreur_pourc_delivred) }]} />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6 ">
                                <div className="card border-0 shadow-sm mb-4">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="mb-0"><span className="subtitle">En cours de livraison</span></h6>
                                                <h3 className="font-weight-normal text-warning mt-2">{livreur.livreur_total_shipped} colis</h3>
                                            </div>
                                            {livreur.livreur_pourc_shipped && (
                                                <div className="col-auto pl-0 align-self-center">
                                                    <div className="w70">
                                                        <Chart data={[{ color: '#ffb400', value: Math.round(livreur.livreur_pourc_shipped) }]} />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6 ">
                                <div className="card border-0 shadow-sm mb-4">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="mb-0"><span className="subtitle">RetourS</span></h6>
                                                <h3 className="font-weight-normal text-danger mt-2">{livreur.livreur_total_undelivered} colis</h3>
                                            </div>
                                            {livreur.livreur_pourc_undelivered && (
                                                <div className="col-auto pl-0 align-self-center">
                                                    <div className="w70">
                                                        <Chart data={[{ color: '#fe656f', value: Math.round(livreur.livreur_pourc_undelivered) }]} />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }

}

export default withRouter(Home);